import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { HttpServices } from './http.service';
import { LoaderService } from './loader.service';
import { ReferenceService } from './reference.service';
import * as config from '../config/config';

@Injectable({ providedIn: 'root' })
export class HomeResolver implements Resolve<number> {

  constructor(
    private loaderService: LoaderService,
    private httpServices: HttpServices,
    private referenceService: ReferenceService
  ) { }

  resolve(route: ActivatedRouteSnapshot): Observable<number> | Promise<number> | number {
    this.loaderService.increaseLoaderCount();
    return this.httpServices.get<number>(
      this.referenceService.staticReferences.Action[config.ApiKeys.GET_NB_LATE_BILLS],
      () => { });
  }
}
